<template>
    <div id='download'>
        <!-- banner -->
        <img class='banner' src="../assets/images/home/banner.png" alt="">


        <div class='type_area download'>
            <!-- title -->
            <div class="title">
                <span>DATA</span>
                <span class="color">DOWNLOAD</span>
            </div>

            <!-- 资料盒子 -->
            <div class="data_box">
                <!-- 资料 -->
                <div class="data" v-for='(item,index) in list' :key='index'>
                    <!-- 左侧图片 -->
                    <div class='img'>
                        <img :src="item.litpic" alt="">
                    </div>
                    
                    <!-- 中间内容 -->
                    <div class="center">
                        <p class="describe">{{item.title}}</p>
                        <p class="_data">{{item.pubdate}}</p>
                    </div>

                    <!-- 右侧按钮 -->
                    <div class="btn">
                        <a :href="item.download" target="_blank"><button>Download</button></a>
                    </div>
                </div>
            </div>


           <!-- &lt;!&ndash; 分页 &ndash;&gt;
           <div class='page'>
               <Page :total="50" @on-change='change' />
           </div> -->
        </div>
    </div>
</template>


<script>
import { constants } from 'crypto';
export default {
    data(){
        return{
            list:[],
            num:20 // 数据总条数
        }
    },

    methods:{
        // 分页
        change(e){
            console.log('当前页码',e)
        }
    },

    mounted() {
        this.$http.get("/api/download.php").then((res)=>{
            this.list = res.data.data;
        })
    }
}
</script>


<style scoped lang="less">
    #download{
        margin: 3rem 0 0;
        min-height: 43.5rem;
        // banner
        .banner{
            width:100%;
        }
        // title
        .title{
            margin: 1rem 0;
            text-align: center;
            font-weight: bold;
            .color{
                color:#257CE1;
                margin-left: 1rem;
            }
        }
        // 资料盒子
        .data_box{
            // 资料
            .data{
                display:flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 2rem;

                // 左侧图片
                .img{
                    width:20%;
                    display:flex;
                    justify-content: center;
                    align-items: center;

                    img{
                        width:80%;
                    }
                }
                // 中间内容
                .center{
                    width:50%;
                    color:#ccc;

                    p{
                        margin-bottom: 5px;
                    }
                    // 描述文本
                    .describe{
                        color:#000;
                        font-size:1.5rem;
                        font-weight: bold;
                        overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
                    }
                    // 时间
                    ._data{
                        margin: 0;
                        text-align: right;
                    }
                }
                // 下载按钮
                .btn{
                    width:20%;
                    padding: 0;
                    height:100%;

                    button{
                        width:100%;
                        height:2rem;
                        background:#257CE1;
                        border:1px solid #257CE1;
                        border-radius: 10px;
                        color:#fff;
                        font-size: 0.5rem;
                    }
                }
            } 
        }

        // 分页
        .page{
            margin: 1rem 0;
            height:4rem;
            display:flex;
            justify-content: center;
        }
    }
</style>
